import * as system from './operationalActions';
import * as user from './userActions';
import * as bess from './bessActions';
import * as metrics from './metricsActions';

export const userActions = user;
export const operationalDataActions = system;
export const bessActions = bess;
export const metricsActions = metrics;
